/**
 * created by yao xiao yan
 * 系统设置-业务开关-业务维护
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import {Button, Pagination, Table, Tooltip} from 'antd';
import {formatTime} from "../../../../utils";
import {permissionCheck} from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import {createSection} from '../../taskJson/createSection'

export default class StoryList extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            count: 0,
            param: {
                num: 1,
                size: 10
            }
        }
    }

    componentWillMount() {
        let that = this;
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                that.getData()
                that.props.callBack&&that.props.callBack()
            }
        }, "StoryList")
    }

    componentDidMount() {
        this.getData()
    }
    componentWillReceiveProps(nextProps, nextContext) {
           this.getData()
    }
    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("StoryList")
    }


    render() {
        let data = permissionCheck("interview_accept") ? createSection['receiverTask'] : createSection['createTask']
        let isAdd = false;
        if (typeof data.conditionFun == "function") {
            isAdd = data.conditionFun(this, window.currentUser);
        }
        return (
            <div style={{padding: '0px 20px'}} className={"taskStory"}>
                {isAdd ? <Button type="primary" style={{marginTop: '24px'}} onClick={() => {
                    this.addStory()
                }}>创建稿件 </Button> : null}

                {this.renderData()}
                <style>{
                    `.taskStory .ant-table-tbody > tr > td{border-bottom: 1px solid #e8e8e8}`
                }</style>
            </div>
        )
    }

    addStory = () => {
        let data  = this.state.data&&this.state.data.taskReporterObjs?this.state.data.taskReporterObjs:[];
        let  myRole=data.filter(item=>(item.reporter.name==window.currentUser.name && item.reporter.account==window.currentUser.account&&item.reporter.currentDept?.id=== window.currentUser.defaultInfo?.dept?.id));
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.cflc", "activitiTreeRoot-task");
        const targetWindow = window.openEditById({
            configName: "taskStoryEditor",
            id: "0",
            params: {
                taskId: this.props.id,
                activitiConfName,
                subtasksId:myRole[0].id
            }
        });
    };

    renderData() {
        let data = permissionCheck("interview_accept") ? createSection['receiverTask'] : createSection['createTask']
        let isAdd = false;
        if (typeof data.conditionFun == "function") {
            isAdd = data.conditionFun(this, window.currentUser);
        }
        let columns = [
            {
                title: '稿件名称',
                dataIndex: 'title',
                ellipsis: true,
                width: 200,
                render: (text, record) => {
                    let content = record.content.replace(/<[^>]*>/g, '');
                    return <div style={{cursor: 'pointer'}} onClick={() => {
                        this.viewStory(record)
                    }}>
                        <Tooltip placement={"topLeft"} title={text}>
                            <div style={{
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}>{text}</div>
                            <div style={{
                                color: 'rgba(0, 0, 0, 0.45)',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}>{content ? content : ''}</div>
                        </Tooltip>
                    </div>
                }
            },
            {
                title: '提交人',
                dataIndex: 'submitterName',
                width: 100,
                ellipsis: true,
            },
            {
                title: '提交时间',
                dataIndex: 'createTime',
                width: 150,
                render: (text, record) => {
                    return (<div>{text ? formatTime(text) : ''}</div>)
                }
            },
            {
                title: '状态',
                width: 150,
                dataIndex: 'statusName',
            },
        ];
        if (permissionCheck("interview_accept")) {
            columns.push({
                title: '操作',
                width: 100,
                render: (text, record) => {
                    if(isAdd){
                        return (<div>
                            {record.statusName === '投稿成功'? null :
                                <div style={{color: "#0050b3", cursor: 'pointer'}} onClick={() => {
                                    let data  = this.state.data&&this.state.data.taskReporterObjs?this.state.data.taskReporterObjs:[];
                                    let  myRole=data.filter(item=>(item.reporter.name==window.currentUser.name && item.reporter.account==window.currentUser.account&&item.reporter.currentDept?.id===window.currentUser.defaultInfo?.dept?.id));
                                    let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.cflc", "activitiTreeRoot-task");
                                    const targetWindow = window.openEditById({
                                        configName: "taskStoryEditor",
                                        id: record.id,
                                        params: {
                                            taskId: this.props.id,
                                            activitiConfName,
                                            subtasksId:myRole[0].id
                                        }
                                    });
                                }}>编辑</div>}
                        </div> )
                    }
                }
            })
        }

        return (
            <Scrollbars
                autoHeight={true}
                autoHeightMax={380}
            >
                <Table dataSource={this.state.dataSource} columns={columns} pagination={false}
                       style={{paddingTop: '24px'}}/></Scrollbars>
        )
    }

    viewStory = (record) => {
        let hideBtn =false;
        let data  = this.state.data&&this.state.data.taskReporterObjs?this.state.data.taskReporterObjs:[];
        let  myRole=data.filter(item=>(item.reporter.id==window.currentUser.id&&item.reporter.currentDept?.id===window.currentUser.defaultInfo?.dept?.id));
        // 状态等于未领取
        if(myRole&&myRole.length&&myRole[0].status =='未领取'){
            hideBtn =true
        }
        // 不是文字记者
        if(myRole&&myRole.length&&Array.isArray(myRole[0].taskRole)&&myRole[0].taskRole.indexOf("文字记者")=== -1) {
            hideBtn =true
        }
        // 没有领取权限
        if(!permissionCheck("interview_accept")){
            hideBtn =true
        }
        if (record.id) {
            let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.cflc", "activitiTreeRoot-task");
            window.openEditById({
                configName: "taskStoryEditor",
                id: record.id,
                params: {
                    taskId: this.props.id,
                    activitiConfName,
                    hideBtn: hideBtn,
                    subtasksId:myRole[0]?.id
                }
            })
        }
    };

    //根据id 获取数据
    getData() {
        let url = '/cm-sites-business/bd/busTask/getById/';
        this.request({
            url: "" + url + this.props.id,
            method: "post",
            body: {
                "showRef": [
                    "taskReporterIds",
                    "clueId",
                    "topicSelectionId"
                ]
            },
            contentType: 'json',
            callBack: (data) => {
                this.setState({data: data});
                if (data && data.storyIds && data.storyIds.length) {
                    this.getStoryList(data.storyIds)
                }
            }
        });
    }

    getStoryList(ids) {
        let url = '/cm-sites-pms/story/getStoryByIds?ids=' + ids.join(',');
        this.request({
            url: url,
            method: "get",
            contentType: 'json',
            callBack: (data) => {
                let array = [];
                if (data && data.length) {
                    array = data;
                    let newArray = [];
                    //创建者不可看草稿
                    if (!permissionCheck("interview_accept")) {
                        array && array.length && array.forEach((item, index) => {
                            if (item.statusName !== '草稿') {
                                newArray.push(item)
                            }
                        });
                        array = newArray
                    }else{
                        //草稿只有本人能看见
                        array && array.length && array.forEach((item, index) => {
                            if(item.statusName ==='草稿'&& item.submitterName === window.currentUser.name){
                                    newArray.push(item)
                            }else if(item.statusName !=='草稿'){
                                newArray.push(item)
                            }
                        });
                        array = newArray
                    }
                }


                this.setState({dataSource: array})
            }
        });
    }
}
